import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ResponsiveTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '50%',
  },
}));
